import { render } from "./MailLink.vue?vue&type=template&id=7b767574&scoped=true"
import script from "./MailLink.vue?vue&type=script&lang=js"
export * from "./MailLink.vue?vue&type=script&lang=js"

import "./MailLink.vue?vue&type=style&index=0&id=7b767574&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b767574"]])

export default __exports__